import React from 'react';
import { scrollToElement } from '../utils/scrollToElement';
/**
 * Critical-path component (above the fold). Optimized for FCP/LCP ≤ 2s on
 * mobile:
 *  - No framer-motion in this file (Button replaced with a plain styled <button>).
 *  - Mobile order: TEXT first, image second — the H1 paints with a system-font
 *    fallback almost immediately and becomes the LCP candidate (instead of the
 *    heavier image). Desktop keeps the image on the right.
 *  - Hero image uses an aggressive small/low-q variant for mobile.
 */
export function Hero() {
  return <section className="relative min-h-[75vh] flex items-center pt-20 pb-10 overflow-hidden" data-id="element-112">
      <div className="max-w-6xl mx-auto px-6 md:px-12 w-full grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-center" data-id="element-113">
        {/* Text block — first on mobile so the H1 becomes the LCP element */}
        <div className="flex flex-col items-start z-10 lg:order-1 lg:pr-4" data-id="element-114">
          <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-6 block" data-id="element-115">
            Un nuevo capítulo en el bienestar femenino
          </span>

          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-ink mb-6 md:mb-8" data-id="element-116">
            Recupera tu <em className="italic text-sand-dark" data-id="element-117">energía</em>,
            balance y <em className="italic text-sand-dark" data-id="element-118">claridad</em>.
          </h1>

          <p className="text-base md:text-lg lg:text-xl text-ink-light font-light leading-relaxed mb-8 md:mb-10 max-w-md" data-id="element-119">
            El método del 1% respaldado por la ciencia para equilibrar tus
            hormonas de forma natural, sin dietas extremas ni agotamiento.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-6" data-id="element-120">
            <button type="button" onClick={() => scrollToElement('precio')} className="inline-flex items-center justify-center bg-sand hover:bg-sand-dark text-white px-8 py-4 text-sm tracking-widest uppercase transition-colors duration-300 active:scale-[0.98]" data-id="element-121">
              Acceso Inmediato
            </button>
            <a href="#method" className="text-sm uppercase tracking-widest text-ink-light hover:text-ink transition-colors border-b border-transparent hover:border-ink pb-1" data-id="element-122">
              Descubre el Método
            </a>
          </div>
        </div>

        {/* Image block — kept small so it never dominates. Natural 4:5
            aspect ratio means the full photo shows without cropping. */}
        <div className="relative w-full max-w-[260px] sm:max-w-[280px] lg:max-w-[180px] mx-auto aspect-[4/5] lg:order-2 lg:ml-auto" data-id="element-123">
          <img src="https://images.unsplash.com/photo-1545389336-cf090694435e?q=85&w=600&auto=format&fit=crop" srcSet="https://images.unsplash.com/photo-1545389336-cf090694435e?q=85&w=400&auto=format&fit=crop 400w, https://images.unsplash.com/photo-1545389336-cf090694435e?q=85&w=600&auto=format&fit=crop 600w, https://images.unsplash.com/photo-1545389336-cf090694435e?q=85&w=900&auto=format&fit=crop 900w" sizes="(max-width: 1024px) 280px, 180px" alt="Mujer serena en plena naturaleza, irradiando vitalidad y equilibrio hormonal" width={600} height={750}
        // @ts-expect-error fetchpriority is valid HTML but typed loosely in React
        fetchpriority="high" loading="eager" decoding="async" className="relative w-full h-full object-cover object-center rounded-2xl shadow-soft-lg bg-sage/20" data-id="element-124" />
        </div>
      </div>
    </section>;
}